<template>
  <header class="project-header"
          @mouseleave="showCreateThingOrRolePopup = false">
    <div class="project-header_left">
      <router-link :to="projectTreeLink"
                   type="button">
        <chevron-left :fill="'#00527F'"></chevron-left>
      </router-link>
      <h1 class="title" :class="{'margin-right-auto': isSettingsTab}">
        <trim-item :string="project.name"
                   :width="1"></trim-item>
      </h1>

      <div v-if="isRolesTab && displayedRolesInCellProjectRoles.length !== 0" @click="toggleAll" class="check-group">
        <checkAllIcon />
        <span class="check-number">{{checkedRolesInCellProjectRoles.length}}</span>
        <span class="check-action">
          {{ checkedRolesInCellProjectRoles.length === displayedRolesInCellProjectRoles.length ? $t('projects.projectsList.deselectAll') : $t('projects.projectsList.selectAll')}}
        </span>
      </div>

      <div v-if="isThingsTab && displayedNowThings.length !== 0" @click="toggleAll" class="check-group">
        <checkAllIcon />
        <span class="check-number">{{checkedThings.length}}</span>
        <span class="check-action">
          {{checkedThings.length === displayedNowThings.length ? $t('projects.projectsList.deselectAll') : $t('projects.projectsList.selectAll')}}
        </span>
      </div>

      <div v-if="isProjectsTab && displayedSectionsInCellProjectTreeField.length !== 0" @click="toggleAll" class="check-group">
        <checkAllIcon />
        <span class="check-number">{{checkedRolesInCellProjectRoles.length}}</span>
        <span class="check-action">
          {{checkedRolesInCellProjectRoles.length === displayedSectionsInCellProjectTreeField.length ? $t('projects.projectsList.deselectAll') : $t('projects.projectsList.selectAll')}}
        </span>
      </div>
    </div>

    <div v-if="isHeaderSettingsEditActive && permissionCheck > 1"
         class="project-header_right">
      <ul class="controls-list header-controls">
        <li class="control-item">
          <button type="button"
                  class="btn btn-transparent_blue"
                  @click="setEditableOffAndClear">
            {{ $t('btns.cancel') }}
          </button>
        </li>
        <li class="control-item">
          <button type="submit"
                  class="btn btn-blue"
                  :class="{'loading': loading}"
                  @click="updateProjectNow">
            {{ $t('btns.save') }}
          </button>
        </li>
      </ul>
    </div>

    <div v-if="!isHeaderSettingsEditActive" class="project-header_right">
      <ul class="controls-list header-controls">
        <li v-if="isFullHeader" class="control-item">
          <button type="button"
                  @click="copyLink"
                  class="control-btn-new hover-blue-new hint-cont">
            <copy-btn :value="link"></copy-btn>
            <p class="btn-hint btn-hint_light btn-hint_bottom copy-hint">
              {{ $t('things.headerSingle.copy') }}
            </p>
          </button>
        </li>
        <li v-if="isFullHeader && permissionCheck > 3"
            class="control-item">
          <button type="button"
                  @click="setEditableOn"
                  class="control-btn-new hover-blue-new hint-cont">
            <edit-icon></edit-icon>
            <p class="btn-hint btn-hint_light btn-hint_bottom copy-hint">
              {{ $t('projects.project.editProperties') }}
            </p>
          </button>
        </li>

        <li class="control-item" v-if="permissionCheck > 3 && isSettingsTab">
          <button type="button"
                  @click="delProjectNow"
                  class="control-btn-new hover-blue-new hint-cont">
            <del-icon></del-icon>
            <p class="btn-hint btn-hint_light btn-hint_bottom_right ">
              <span v-if="$route.name === 'project-edit'">{{ $t('projects.header.delete') }}</span>
              <span v-else>{{ $t('projects.header.delThisSection') }}</span>
            </p>
          </button>
        </li>

        <li class="control-item"
            v-if="checkedRoles.length && isProjectsTab && permissionCheck > 3">
          <button type="button"
                  @click="setShowRemoveProject"
                  class="control-btn-new hover-blue-new hint-cont">
            <del-icon></del-icon>
            <p class="btn-hint btn-hint_light btn-hint_bottom_right ">
              {{ $t('projects.header.delSection') }}
            </p>
          </button>
        </li>

        <li class="control-item"
            v-if="checkedRoles.length && isRolesTab && permissionCheck > 2">
          <button type="button"
                  @click="setShowRemoveRole"
                  class="control-btn-new hover-blue-new hint-cont">
            <link-break-icon></link-break-icon>
            <p class="btn-hint btn-hint_light btn-hint_bottom_right ">
              {{ $t('projects.header.revokeRole') }}
            </p>
          </button>
        </li>

        <li class="control-item"
            v-if="checkedThings.length && isThingsTab && !isMotherPage && permissionCheck > 2">
          <button type="button"
                  @click="setShowRemoveThing"
                  class="control-btn-new hover-blue-new hint-cont">
            <link-break-icon></link-break-icon>
            <p class="btn-hint btn-hint_light btn-hint_bottom_right ">
              {{ $t('projects.header.revokeThing') }}
            </p>
          </button>
        </li>

        <li v-if="!isFullHeader && permissionCheck > 3"
            class="control-item">
          <button type="button"
                  @mouseenter="showCreateThingOrRolePopup = true"
                  class="btn-main-plus hint-cont">
            <plus-icon></plus-icon>
          </button>
          <addRoleOrThing class="add-list"
                          :permission="permissionCheck"
                          v-show="showCreateThingOrRolePopup"></addRoleOrThing>
        </li>

      </ul>
    </div>
  </header>
</template>

<script>
import {mapState, mapMutations, mapGetters, mapActions} from 'vuex'
import {singleProject} from "../../../mixins/projects/singleProject";
import {delItem2} from "../../../mixins/delItem2";
import {loaderMixin} from "../../../mixins/utils/loaderMixin";
import {showOverlay} from "../../../mixins/utils/showOverlay"
import {delItem} from "../../../mixins/delItem";
import delIcon from '../../Svg/cart_control/delIcon'
import plusIcon from '../../Svg/plusIcon'
import dotsIcon from '../../../components/Svg/things/dotsIcon'
import copyLinkIcon from '../../../components/Svg/things/copyLinkIcon'
import editIcon from '../../../components/Svg/projects/editIcon'
import addRoleOrThing from './OtherComponents/addRoleOrThing'
import copyBtn from '../../../components/copyBtnHint'
import gearIcon from '../../../components/Svg/gearIcon'
import trimItem from '../../../components/trimITem';
import linkBreakIcon from '../../../components/Svg/projects/linkBreak';
import chevronLeft from "@/components/Svg/chevronLeft";
import checkAllIcon from '../../Svg/projects/checkAllIcon'

export default {
  name: "projectHeader",
  mixins: [showOverlay, singleProject, delItem, loaderMixin, delItem2],
  components: {
    delIcon,
    plusIcon,
    addRoleOrThing,
    dotsIcon,
    copyLinkIcon,
    editIcon,
    copyBtn,
    gearIcon,
    trimItem,
    linkBreakIcon,
    chevronLeft,
    checkAllIcon
  },
  data() {
    return {
      title: '',
      showMenu: false,
      showCombine: false,
      showCreateThingOrRolePopup: false,
      loading: false
    }
  },
  computed: {
    ...mapState({
      thisProject: state => state.projects.singleProject,
      isHeaderSettingsEditActive: state => state.projects.isHeaderSettingsEditActive,
      isFullHeader: state => state.projects.isFullHeader,
      onEditingInputs: state => state.projects.onEditingInputs,
      routeName: state => state.sidebar.routeName,
      dirName: state => state.projects.dirName,
      checkedRoles: state => state.projects.checkedRoles,
      delHookRole: state => state.projects.delHookRoles,
      activeHeaderTab: state => state.projects.activeHeaderTab,
      checkedThings: state => state.things.checkedThingList,
      delHookThing: state => state.projects.delHookThing,
      displayedNowThings: state => state.things.displayedNowThings,
      displayedRolesInCellProjectRoles: state => state.projects.displayedRolesInCellProjectRoles,
      displayedSectionsInCellProjectTreeField: state => state.projects.displayedSectionsInCellProjectTreeField,
      checkedRolesInCellProjectRoles: state => state.projects.checkedRoles
    }),
    ...mapGetters({
      getRouteName: 'sidebar/getRouteName'
    }),
    checkedThingsAll: {
      get() {
        return this.checkedThings
      },
      set(val) {
        this.setCheckedThings(val)
      }
    },
    checkedRolesAll: {
      get() {
        return this.checkedRolesInCellProjectRoles
      },
      set(val) {
        this.setCheckedRoles(val)
      }
    },
    checkedSectionsAll: {
      get() {
        return this.checkedRolesInCellProjectRoles
      },
      set(val) {
        this.setCheckedRoles(val)
      }
    },
    isMotherPage() {
      return this.$route.name === 'project-edit'
    },
    link() {
      return window.location.href
    },
    isRolesTab() {
      return this.activeHeaderTab === 'projectRoles'
    },
    isThingsTab() {
      return this.activeHeaderTab === 'projectThings'
    },
    isProjectsTab() {
      return this.activeHeaderTab === 'projectTreeList'
    },
    isSettingsTab() {
      return this.activeHeaderTab === 'projectSettings'
    },
    projectTreeLink() {
      const routeParams = this.$route.params;
      let projectLink =  `/project/${routeParams.id}`
      if (routeParams.item) {
        return `${projectLink}/project-item/${routeParams.item}`
      }
      return projectLink
    },
    delNames() {
      let string = '';
      this.checkedRoles.forEach((item) => {
        // string += `${item.role.name}, `
        string += `${item.name}, `
      });
      string = string.slice(0, -2);
      return string
    },
    delNamesProjects() {
      let string = '';
      this.checkedThings.forEach((item) => {
        // string += `${item.role.name}, `
        string += `${item.name}, `
      });
      string = string.slice(0, -2);
      return string
      },
    },
    watch: {
      thisProject() {
        this.findProject()
      },
      async delHookRole(val) {
        if (val) {
          let id;
          let ids;
          id = this.$route.params.id

          this.showLoader();
          this.checkedRoles.forEach((item, index) => {
            if (index === 0) {
              ids = item.permission.id
            } else {
              ids = `${ids}, ${item.permission.id}`
            }
          });
          await this.removePermission({data: {ids: ids}, id})
          this.hideLoader();
          this.setCheckedRoles([])
        }
      },
      async delHookThing(val) {
        if (val) {
          let id;
          id = this.$route.params.id
          this.showLoader();
          for (let thing of this.checkedThings) {
            await this.delDeviceFromProject({
              data: {
                device_id: thing.id,
                project_item_id: this.$route.params.item
              }
            })
          }
          ;
          await this.getProjects();
          this.hideLoader();
          this.setCheckedThings([])
        }
      }
    },
  methods: {
    copyLink() {
      let text = document.createElement('input');
      text.value = window.location.href;
      document.body.appendChild(text);
      text.select();
      document.execCommand('copy');
      document.body.removeChild(text);
    },
    ...mapMutations({
      showDelPopup: 'popups/del/SET_SHOW',
      setShowDelRoleProjects: 'projects/SET_SHOW_DEL_ROLE_PROJECT',
      setCheckedRoles: 'projects/SET_CHECKED_ROLES',
      setShowDelThing: 'projects/SET_SHOW_DEL_THING_PROJECT',
      setCheckedThings: 'things/SET_CHECKED_THINGS_LIST',
    }),
    ...mapActions({
      removePermission: 'projects/removePermission',
      delProjectItem: 'projects/delProjectItem',
      getProject: 'projects/getProject',
      delDeviceFromProject: 'projects/delDeviceFromProject',
      getProjects: 'projects/getProjects',
    }),
    toggleAll() {
      if (this.isThingsTab) {
        if (this.checkedThingsAll.length === this.displayedNowThings.length) {
          this.checkedThingsAll = []
        } else {
          this.checkedThingsAll = this.displayedNowThings
        }
      }
      if (this.isRolesTab) {
        if (this.checkedRolesAll.length === this.displayedRolesInCellProjectRoles.length) {
          this.checkedRolesAll = []
        } else {
          this.checkedRolesAll = this.displayedRolesInCellProjectRoles
        }
      }
      if (this.isProjectsTab) {
        if (this.isProjectsTab) {
          if (this.checkedSectionsAll.length === this.displayedSectionsInCellProjectTreeField.length) {
            this.checkedSectionsAll = []
          } else {
            this.checkedSectionsAll = this.displayedSectionsInCellProjectTreeField
          }
        }
      }
    },
    setShowRemoveRole() {
      this.showOverlay(true);
      this.setShowDelRoleProjects(this.delNames)
    },
    setShowRemoveThing() {
      this.showOverlay(true);
      this.setShowDelThing(this.delNamesProjects);
    },
    async deleteItems2() {
      let id;
      id = this.$route.params.id

      this.showLoader();
      for (let item of this.checkedRoles) {
        await this.delProjectItem(item.id)
      }
      ;
      await this.getProject(id);
      this.hideLoader();
      this.setCheckedRoles([])
    },
    setShowRemoveProject() {
      this.showOverlay(true);
      this.showDelPopup(true);
      this.setDelItems(this.delNames);
      this.setNumberDel(2);
    },
    delProjectNow() {
      // console.log(this.$route)
      this.showOverlay(true);
      this.setDelItems(this.project.name);
      this.showDelPopup(true);
    },
    async deleteItems() {
      let name;
      let id;
      if (this.$route.name.includes('projectItem')) {
        name = 'delProjectItem';
        id = this.$route.params.item;
      } else {
        name = 'delProject';
        id = this.$route.params.id
      }
      ;
      await this[name](id).then(() => {
        this.getProjects();
        this.$router.push({name: 'projects'})
      })
    },
    ...mapMutations({
      setSettingsNodeEditable: 'projects/SET_SETTINGS_NODE_EDITABLE',
      setHeaderSettingsEditActive: 'projects/SET_HEADER_SETTINGS_EDIT_ACTIVE'
    }),
    ...mapActions({
      updateProject: 'projects/updateProject',
      updateProjectItem: 'projects/updateProjectItem',
      setEditedName: 'projects/setEditedName',
      getProject: 'projects/getProject',
      getProjects: 'projects/getProjects',
      delProject: 'projects/delProject',
      delProjectItem: 'projects/delProjectItem',
      delProjectImage: 'projects/delProjectImage',
      delProjectItemImage: 'projects/delProjectItemImage'
    }),
    setEditableNodeSettings(val) {
      this.setSettingsNodeEditable(val);
      this.setHeaderSettingsEditActive(val)
    },
    setEditableOn() {
      this.setEditableNodeSettings(true)
    },
    setEditableOffAndClear() {
      this.setEditableNodeSettings(false)
    },
    async updateProjectNow() {
      let methodName = '';
      let delImgName = '';
      let id = '';
      const image = this.onEditingInputs.image;
      this.loading = true;

      setIdAndName(this);

      let data = {
        name: this.onEditingInputs.name,
        description: this.onEditingInputs.description,
        virtual: 0,
        id
      };

      addImage();
      await delImage(this);

      let formData = setFormData();

      await this[methodName](formData)
        .then(async () => {
          await this.getProject(this.$route.params.id);
          this.setEditableOffAndClear()
        }).then(async () => {
          await this.getProjects()
        });
      this.loading = false;

      function setIdAndName(cntx) {
        if (cntx.$route.name.includes('projectItem')) {
          id = cntx.$route.params.item;
          methodName = 'updateProjectItem';
          delImgName = 'delProjectItemImage'
        } else {
          id = cntx.$route.params.id;
          methodName = 'updateProject';
          delImgName = 'delProjectImage'
        }
        ;
      };

      function setFormData() {
        let formData = new FormData();
        for (let key in data) {
          formData.append(key, data[key]);
        }
        ;
        return formData
      };

      function addImage() {
        if (!!image && image !== 'del') {
          data.image = image
        }
        ;
      };

      async function delImage(cntx) {
        if (image === 'del') {
          await cntx[delImgName](id)
        }
        ;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.project-header {
  padding: 20px;
  box-shadow: inset 0px -1px 0px #D7E3EA;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 90px;
  z-index: 1;
  background: #f5f8fa;

  .title {
    max-width: 400px;
  }
}

.project-header_left {
  display: flex;
  align-items: center;
}

.check-group {
  margin-right: auto;
  min-width: 150px;
  height: 40px;
  border: 1px solid rgba(16, 156, 241, 0.36);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.25px;
  color: #109CF1;

  svg {
    margin-right: 10px;
    margin-left: 18px;
  }

  .check-number {
    margin-right: auto;
  }

  .check-action {
    cursor: pointer;
    margin: 0 18px;
  }
}

.title {
  font-family: $msb;
  font-size: 18px;
  letter-spacing: .25px;
  color: $darkBlue;
  margin-right: 40px;
  max-width: 100%;
}

.margin-right-auto {
  margin-right: auto;
}

.project-header_right {
  display: flex;
  align-items: center;
}

.hover-blue_active {
  box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
}

.view-controls {
  display: flex;
  align-items: center;
  margin: 0 -10px;
}

.view-control {
  margin: 0 10px;
}

.view-cont {
  display: flex;
  align-items: center;
  margin-right: 80px;
}

.view-label {
  font-family: $mm;
  font-size: 14px;
  margin-right: 20px;
}

.header-controls {
  display: flex;
  align-items: center;
  margin: 0 -10px;

  .control-item {
    margin: 0 10px;
    position: relative;
  }
}

.combine-list, .add-list {
  top: calc(100% - -10px);
  right: calc(100% - 42px);
}

.btn {
  width: 200px;
}

.btn-main-plus {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0) 100%), $green !important;

  svg path {
    fill: white;
  }
}
</style>
